<template>
  <router-view />
  <ToastComponent />
</template>
